import { useEffect, useState } from "react";

/**
 * An online booking still waiting for its card or deposit: the time is only held, and it's let go
 * when the countdown runs out. Shown in place of the visit's status.
 */
export function HoldBadge({ until, compact }: { until: string; compact?: boolean }) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 15_000);
    return () => clearInterval(t);
  }, []);
  const mins = Math.max(0, Math.ceil((Date.parse(until) - now) / 60_000));
  return (
    <span
      className="inline-flex items-center gap-1 rounded-full border border-dashed border-[#d97706] bg-[#fef3c7] px-2 py-0.5 text-xs font-semibold text-[#92400e]"
      title="They started booking online but haven't added their card yet. The time is held until then; if they don't finish, it's let go and you'll get a Booking not finished alert."
    >
      ⏳ {compact ? `${mins} min` : mins > 0 ? `Waiting for card · ${mins} min left` : "Waiting for card · letting go"}
    </span>
  );
}

/** A held (unfinished) booking's look on the calendar: amber stripes. */
export const HOLD_BACKGROUND = "repeating-linear-gradient(135deg, #fef3c7 0 8px, #fde68a 8px 16px)";
